import * as stylex from "@stylexjs/stylex";
import {
  colors,
  fonts,
  fontSizes,
  radii,
  spacing,
} from "@softmax/design-system/tokens.stylex";

export const fieldStyles = stylex.create({
  text: { margin: 0, boxSizing: "border-box" },
  body: {
    fontFamily: fonts.sans,
    fontSize: fontSizes.label,
    lineHeight: 1.5,
    color: colors.secondary,
  },
  beatTitle: {
    fontFamily: fonts.mono,
    fontSize: fontSizes.body,
    lineHeight: 1.3,
    fontWeight: 600,
    color: colors.foreground,
  },
  linkLabel: {
    fontFamily: fonts.mono,
    fontSize: fontSizes.small,
    lineHeight: 1.4,
    color: colors.foreground,
  },
  cta: {
    minWidth: "6ch",
    fontFamily: "inherit",
    fontSize: "inherit",
    lineHeight: "inherit",
    color: "inherit",
  },
  field: { position: "relative", display: "block", minWidth: 0, width: "100%" },
  input: {
    display: "block",
    width: "100%",
    resize: "none",
    overflow: "hidden",
    backgroundColor: "transparent",
    padding: spacing.space2,
    borderWidth: 1,
    borderStyle: "dashed",
    borderColor: colors.borderStrong,
    borderRadius: radii.small,
    outline: {
      default: "none",
      ":focus-visible": `2px solid ${colors.selected}`,
    },
    outlineOffset: 2,
    opacity: { default: 1, ":disabled": 0.6 },
  },
  meta: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "baseline",
    gap: spacing.space8,
    marginTop: spacing.space2,
  },
  caption: {
    fontFamily: fonts.mono,
    fontSize: fontSizes.caption,
    lineHeight: 1.4,
    color: colors.muted,
  },
  warning: { color: colors.danger },
  warnings: {
    display: "flex",
    flexDirection: "column",
    gap: spacing.space2,
    marginTop: spacing.space2,
  },
});
